<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span id="dlgCategoryTitle" class="title dialog-title"
        >Task Notification Recipients</span
      >
      <button
        id="dlgCategoryClose"
        mat-icon-button
        class="mat-icon-button white-fg"
        (click)="dialogRef.close()"
        aria-label="Close dialog"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar>
    <form
      class="addDialog"
      [formGroup]="form"
      #formControl="ngForm"
      fxLayout="column"
      fxFlex
    >
      <div class="pb-24">
        Please select the people you want to receive task notifications
      </div>

      <div
        formArrayName="items"
        *ngFor="let item of form?.controls.items.controls; let i = index"
      >
        <mat-checkbox
          class="form-control px-8"
          [formControlName]="i"
          (change)="changeReceiveTaskNotification($event, item)"
          >{{ peopleSubjects[i].Reference }}</mat-checkbox
        >
      </div>

      <!-- <app-check-list
        [multiselect]="true"
        [list]="this.peopleSubjectsNames"
        (onChanged)="receiveTaskNotificationChanged($event)"
      ></app-check-list> -->

      <!-- <mat-form-field>
        <mat-label>People</mat-label>
        <mat-select
          class="form-control py-8"
          formControlName="person"
          class="form-control px-8"
          id="person"
          name="person"
          required
        >
          <mat-option
            *ngFor="let item of peopleSubjects"
            [value]="item.receiveTaskNotification"
          >
            {{ item.fullName }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->
    </form>
  </div>

  <div
    mat-dialog-actions
    class="m-0 p-24"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <div>
      <button
        id="btnNotificationSave"
        mat-raised-button
        type="submit"
        (click)="confirmSubmit()"
        class="save-button mat-accent"
        aria-label="SAVE"
      >
        SAVE
      </button>
    </div>
  </div>
</div>
